export const sanitizeFilename = (filename: string) => {
  // Trim leading/trailing whitespace
  let sanitized = String(filename).trim()

  // Replace invalid characters with a hyphen.
  // Invalid characters for most file systems: / \ : * ? " < > |
  // Also handle characters that might cause issues or are generally undesirable in filenames.
  sanitized = sanitized.replace(/[\\/:*?"<>|&%$#!@^()+=~`{}[\];,']/g, '-')

  // Replace multiple consecutive hyphens or spaces with a single hyphen
  sanitized = sanitized.replace(/[\s-]+/g, '-')

  // Remove leading/trailing hyphens (if any resulted from replacements)
  sanitized = sanitized.replace(/^-+|-+$/g, '')

  const maxLength = 200

  if (sanitized.length > maxLength) {
    // Try to preserve the extension if present
    const parts = sanitized.split('.')

    if (parts.length > 1) {
      const extension = parts[parts.length - 1]
      const name = parts.join('.')

      sanitized = name.substring(0, maxLength - extension.length - 1) + '.' + extension
    } else {
      sanitized = sanitized.substring(0, maxLength)
    }
  }

  return sanitized
}
